var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10.2856,
    width: 12,
    height: 8.57143,
    rx: 1,
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4284 10.2857V8.57139C15.4284 6.67785 13.8934 5.14282 11.9999 5.14282V5.14282C10.1063 5.14282 8.57129 6.67785 8.57129 8.57139V10.2857",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.8572V15.4286",
    stroke: "white",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.0a1682fcb14468e8279c2f44af69d48d.svg";
export { ForwardRef as ReactComponent };